import { KazooError } from "@kazoohr/types";
import { AssertionErrorFactory } from "./assertionErrorFactory";

export function assertIsUndefined<T>(
  variable?: T,
  errorFactory: AssertionErrorFactory<T> = (variable) => {
    return new KazooError(
      `Expected variable ${JSON.stringify(
        variable
      )} to be undefined! It was instead ${typeof variable}`,
      { variable }
    );
  }
): asserts variable is undefined {
  if (variable !== undefined) {
    throw errorFactory(variable);
  }
}
